import { parseDomain } from '@wix/domains-serverless-interface';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { ModalsModule } from '@wix/domains-search-suite';
import { fetchWithFallback } from '@wix/premium-fed-sdk/@apis-infra';
import { getPremiumEssentials } from '@wix/premium-fed-sdk/@premium-essentials';
import { MobileDomainTaken } from '../../Components/StatusesOverrides/LoggedInMobile/MobileDomainTaken';
import { MobileSubdomainRootTaken } from '../../Components/StatusesOverrides/LoggedInMobile/MobileSubdomainRootTaken';
import { buildMobileEntriDivertStatus } from './mobileEntriDivertStatus';
export const divertDomainTakenInWixToConnectIntro = async (_ref, _ref2) => {
  let domainName = _ref.domainName,
    metaSiteId = _ref.metaSiteId,
    siteName = _ref.siteName;
  let onConnectIntro = _ref2.onConnectIntro,
    onConnectManual = _ref2.onConnectManual,
    onConnectError = _ref2.onConnectError;
  const loaderModal = ModalsModule.internals.domainsSharedModalsController.loaderModal;
  const domainTakenInWix = ModalsModule.internals.domainsActionsModalsController.domainTakenInWix;
  const _getPremiumEssentials = getPremiumEssentials(),
    httpClient = _getPremiumEssentials.httpClient;
  // Both reads resolve against the root domain, the same as the suite's handler.
  const domain = parseDomain(domainName).main ?? domainName;
  try {
    loaderModal.show({});
    const _await$Promise$all = await Promise.all([fetchWithFallback(DomainsApiClient.query.canChangeDomainOwner({
        httpClient: httpClient,
        request: {
          domain
        }
      }), {
        canChangeOwner: false
      }), DomainsApiClient.query.domainTakenInAnotherAccountEntriEligibility({
        httpClient: httpClient,
        request: {
          domain
        }
      })]),
      canChangeOwner = _await$Promise$all[0].canChangeOwner,
      entriEligibility = _await$Promise$all[1];
    loaderModal.hide();
    if (entriEligibility.isEligible) {
      await (onConnectIntro == null ? void 0 : onConnectIntro({
        domainName: domain,
        metaSiteId,
        siteName,
        takenInAnotherAccount: true
      }));
      return;
    }
    if (canChangeOwner) {
      await (onConnectManual == null ? void 0 : onConnectManual({
        domainName: domain,
        metaSiteId
      }));
      return;
    }
    domainTakenInWix.show({
      domain
    });
  } catch {
    loaderModal.hide();
    onConnectError == null || onConnectError();
  }
};
export const buildMobileDomainTakenInWixStatus = buildMobileEntriDivertStatus({
  divert: divertDomainTakenInWixToConnectIntro,
  StatusComponent: MobileDomainTaken
});
export const buildMobileSubdomainTakenInWixStatus = buildMobileEntriDivertStatus({
  divert: divertDomainTakenInWixToConnectIntro,
  StatusComponent: MobileSubdomainRootTaken
});
//# sourceMappingURL=mobileDomainTakenInWixStatus.js.map